import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=3cd0569f&scoped=true&"
import script from "./ServicesSection.vue?vue&type=script&lang=js&"
export * from "./ServicesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0569f",
  null
  
)

export default component.exports